
<div class="col-12 basket-added-element grow-big" [ngClass]="{'grow-small': basketNotify && itemCount > 1, 'grow-big': basketNotify && itemCount == 1 }">
    <div class="row">
        <div class="col-5 order-container">
            <span class="order-number">1</span>
            <span class="order-super">X</span>
            <div class="order-icon order-icon-{{ addedItemType }} order-icon-{{ addedItemType }}--{{ addedItemNormalizedName }}"></div>
        </div>
        <div class="col-7 mb-2">
            <h5>{{ addedItemName }}</h5>
        </div>
    </div>
</div>
